module.exports = __webpack_public_path__ + "media/images/places/escola-ubaldo-383c5acdb2246e4f2d41f8bc1f1853e1.jpg";